import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { LanguageProvider } from "./components/LanguageTranslator/LanguageContext";
import { Provider } from "react-redux";
import store from './redux/store';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <LanguageProvider>
    <Provider store={store}>
    <App />
    </Provider>
</LanguageProvider>,
);

